import React from "react";
import styled from "@emotion/styled";
import { useMsal } from "@azure/msal-react";
import { Power } from "react-feather";

import { Box, Grid, Typography, Menu, MenuItem } from "@mui/material";

const Footer = styled.div`
  background-color: ${(props) =>
    props.theme.sidebar.footer.background} !important;
  padding: ${(props) => props.theme.spacing(2.75)}
    ${(props) => props.theme.spacing(4)};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  cursor: pointer;
  &:hover {
    background-color: ${(props) =>
      props.theme.sidebar.footer.background} !important;
    opacity: 0.9;
  }
`;

const FooterText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
  font-size: 0.875rem;
`;

type SidebarFooterProps = {
  collapsed?: boolean;
};

const SidebarFooter: React.FC<SidebarFooterProps> = ({
  collapsed = false,
  ...rest
}) => {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = () => {
    handleClose();
    instance.logoutRedirect();
  };

  return (
    <>
      <Footer
        {...rest}
        onClick={handleClick}
        style={{ justifyContent: collapsed ? "center" : "flex-start" }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                justifyContent: collapsed ? "center" : "flex-start",
              }}
            >
              <Power size={16} color="#fff" />
              {!collapsed && (
                <FooterText>{activeAccount?.name || "User"}</FooterText>
              )}
            </Box>
          </Grid>
        </Grid>
      </Footer>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <MenuItem onClick={handleSignOut}>Sign out</MenuItem>
      </Menu>
    </>
  );
};

export default SidebarFooter;
